<template>
    <v-select
          :items="items"
          label="Solo field"
          solo
      ></v-select>
</template>

<script>
export default {
  name: 'CompTest'
}
</script>


// WEBPACK FOOTER //
// src/views/CompTest.vue